import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  newNotifications: [],
  currentNotifications: [],
  loading: false,
  error: false,
};

export const notifSlice = createSlice({
  name: "notification",
  initialState,
  reducers: {
    fetchNotificationStart: (state) => {
      state.loading = true;
    },
    fetchNotificationSuccess: (state, action) => {
      state.currentNotifications = action.payload;
      state.loading = false;
      state.error = false;
    },
    fetchNotificationFailure: (state) => {
      state.loading = false;
      state.error = false;
    },
    createNotificationStart: (state) => {
      state.loading = true;
    },
    createNotificationSuccess: (state, action) => {
      state.newNotifications = state.newNotifications.push(action.payload);
      state.loading = false;
      state.error = false;
    },
    createNotificationFailure: (state) => {
      state.loading = false;
      state.error = false;
    },
    switchStateNotificationStart: (state) => {
      state.loading = true;
    },
    switchStateNotificationSuccess: (state, action) => {
      state.currentNotifications[
        state.currentNotifications.map(
          (notif) => notif._id === action.payload.notificationId
        )
      ] = action.payload;
      state.loading = false;
      state.error = false;
    },
    switchStateNotificationFailure: (state) => {
      state.loading = false;
      state.error = false;
    },
  },
});

export const {
  fetchNotificationStart,
  fetchNotificationSuccess,
  fetchNotificationFailure,
  createNotificationStart,
  createNotificationSuccess,
  createNotificationFailure,
  switchStateNotificationStart,
  switchStateNotificationSuccess,
  switchStateNotificationFailure,
} = notifSlice.actions;
export default notifSlice.reducer;
